// @flow
import React from 'react';
import { Route, Redirect } from 'react-router-dom';

export default function PrivateRoute({
  path,
  component: Component,
  authenticate,
  redirect,
  keepPath,
  ...rest
}: {
  path: string,
  component: Object,
  authenticate: Function,
  redirect: string,
  keepPath?: boolean,
}) {
  const authenticated = authenticate();
  let search;

  if (!authenticated && keepPath && path) {
    const params = new URLSearchParams({ redirect: path });
    search = params.toString();
  }

  return (
    <Route
      path={path}
      {...rest}
      render={props =>
        authenticated ? (
          <Component {...props} />
        ) : (
          <Redirect
            to={{
              pathname: redirect,
              search,
            }}
          />
        )
      }
    />
  );
}
